<template>
  <div class="privacy">
    <header-top :headerPosition="false">
      <div slot="title">已收集个人信息清单</div>
    </header-top>
    <div class="privacy-wrapperOther">
      <table class="tabOther" width="98%" border="1" cellspacing="0">
        <tr class="thead">
          <th class="tr1">使用场景/业务功能</th>
          <th class="tr2">使用目的</th>
          <th class="tr3">收集个人信息类型</th>
        </tr>
        <tr>
          <th class="tr1" rowspan="2">注册登录</th>
          <th class="tr2">用户注册创建账号</th>
          <th class="tr3">手机号、昵称、性别、生日、头像</th>
        </tr>
        <tr>
          <th class="tr2">第三方SDK提供登录服务</th>
          <th class="tr3">第三方账号（头像、昵称及其他授权信息）、绑定手机号</th>
        </tr>
        <tr>
          <th class="tr1">个人主页</th>
          <th class="tr2">用户完善个人主页</th>
          <th class="tr3">身高、体重、标签设置、职业、收入情况、工作区域、家乡、婚姻状况、住房情况、用户真实头像、择偶条件、录制语音、交友心声、微信号码</th>
        </tr>
        <tr>
          <th class="tr1">浏览查看附近用户、附近交友房间</th>
          <th class="tr2">用户查看附近用户、附近交友房间</th>
          <th class="tr3">地理位置</th>
        </tr>
        <tr>
          <th class="tr1">发布图文/音视频、发表评论、关注、分享、点赞等功能</th>
          <th class="tr2">信息发布</th>
          <th class="tr3">相册、相机、麦克风、相关发布内容</th>
        </tr>
        <tr>
          <th class="tr1">实名认证（提现）</th>
          <th class="tr2">第三方SDK提供实名认证服务</th>
          <th class="tr3">真实姓名、身份证号码、生物识别特征</th>
        </tr>
        <tr>
          <th class="tr1">支付</th>
          <th class="tr2">为用户提供支付充值服务</th>
          <th class="tr3">支付信息</th>
        </tr>
        <tr>
          <th class="tr1">提现</th>
          <th class="tr2">第三方SDK提供提现服务</th>
          <th class="tr3">支付宝账户信息、身份认证信息</th>
        </tr>
        <tr>
          <th class="tr1">消息聊天</th>
          <th class="tr2">发送图片、音视频等</th>
          <th class="tr3">相册、相机、麦克风</th>
        </tr>
        <tr>
          <th class="tr1">客服沟通</th>
          <th class="tr2">帮助用户解决问题</th>
          <th class="tr3">通信/通话记录和内容（包括用户的账户信息、提供的相关投诉材料等）、用户联系方式、身份核验信息</th>
        </tr>
        <tr>
          <th class="tr1">安全保障</th>
          <th class="tr2">保障用户安全使用服务</th>
          <th class="tr3">用户信息、设备信息、有关网络日志</th>
        </tr>
      </table>
    </div>
  </div>
</template>
<style lang="scss">
.tabOther {
  margin: 0 auto;
  margin-bottom: 20px;
  line-height: 30px;
  color: #9a9eb9;
  text-align: center;
  border-color: #eee;
  table-layout: fixed;
  word-break: break-all;
  tr {
    font-size: 16px;
    .tr7 {
      word-break: break-all;
    }
  }
}
.thead {
  color: #3f446f;
  font-size: 24px;
  line-height: 30px;
  margin-top: 7px;
  text-align: center;
}
.privacy {
  background-color: #f6f5fb;
  padding-bottom: 130px;
}
.privacy-wrapperOther {
  padding-top: 120px;
  padding: 120px 10px 0;
  width: 730px;
  text-align: left;
}
.privacy-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.privacy-date {
  margin-left: 300px;
  margin-bottom: 4px;
  text-align: right;
  font-size: 26px;
  width: 390px;
  color: #3f446f;
}
.privacy-date-second {
  margin-bottom: 20px;
}
.privacy-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";

export default {
  name: "Privacy",
  data() {
    return {
      appName: this.$store.state.appName
    };
  },
  mounted() {
    console.log("appName:", this.appName);
  },
  components: {
    "header-top": HeaderTop // 顶部导航组件
  }
};
</script>
